var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tooltip',{attrs:{"text":"A proper URL starts with https:// or http://"}})
}
var staticRenderFns = []

export { render, staticRenderFns }